import { darkTheme } from '@rainbow-me/rainbowkit';

export const RainbowKitTheme = darkTheme({
  // accentColor: '#6673FF',
  borderRadius: 'large',
  fontStack: 'system',
});
